import { GridColDef } from "@bvhi/ui-base";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DateCell } from "../../../../../components/datagrid/cells/date-cell";
import { MessageTypeCell } from "../components/message-type-cell";
import { useMessagesSortParams } from "./use-messages-sort-params";
import { PlatformMessageListItemDTO } from "@bvhi/backend-api/apis";
import { MessageDetailLinkCell } from "../components/message-detail-link-cell";
import { PrimaryChanelStatusCell } from "../components/primary-channel-status-cell";
import { ValidationStatusChip } from "../../../supplier-customer-list/components/common/validation-status-chip";

export const useMessagesDataGridDefinitions = () => {
  const { t } = useTranslation(["messages"]);
  const { isFieldSortable } = useMessagesSortParams();

  const columns: GridColDef<PlatformMessageListItemDTO>[] = useMemo(() => {
    return [
      {
        field: "purchaseOrderReference",
        headerName: t("messages:datagrid.purchaseOrderReference"),
        minWidth: 150,
        width: 200,
        maxWidth: 300,
        sortable: isFieldSortable("purchaseOrderReference"),
        renderCell: (params) => (
          <MessageDetailLinkCell label={params.row.purchaseOrderReference} messageId={params.row.id ? params.row.id : "-1"} />
        ),
      },
      {
        field: "orderNumber",
        headerName: t("messages:datagrid.orderNumber"),
        minWidth: 150,
        width: 200,
        maxWidth: 300,
        sortable: isFieldSortable("orderNumber"),
      },

      {
        field: "customerNumber",
        headerName: t("messages:datagrid.customerNumber"),
        minWidth: 150,
        width: 250,
        maxWidth: 500,
        sortable: isFieldSortable("customerNumber"),
      },

      {
        field: "primaryChannelStatus",
        headerName: t("messages:datagrid.primaryChannelStatus"),
        minWidth: 150,
        width: 175,
        maxWidth: 300,
        sortable: isFieldSortable("primaryChannelStatus"),
        renderCell: (params) => <PrimaryChanelStatusCell type={params.row.primaryChannelStatus} />,
      },

      {
        field: "type",
        headerName: t("messages:datagrid.type"),
        minWidth: 150,
        width: 150,
        maxWidth: 300,
        sortable: isFieldSortable("type"),
        renderCell: (params) => <MessageTypeCell type={params.row.type} />,
      },
      {
        field: "validationStatus",
        headerName: t("messages:datagrid.validationStatus"),
        minWidth: 150,
        width: 175,
        maxWidth: 300,
        sortable: isFieldSortable("validationStatus"),
        renderCell: (params) => <ValidationStatusChip status={params.row.validationStatus} />,
      },
      {
        field: "supplierCode",
        headerName: t("messages:datagrid.supplierCode"),
        minWidth: 150,
        width: 250,
        maxWidth: 300,
        sortable: isFieldSortable("supplierCode"),
      },
      {
        field: "createdAt",
        headerName: t("messages:datagrid.createdAt"),
        minWidth: 150,
        width: 200,
        maxWidth: 300,
        sortable: isFieldSortable("createdAt"),
        renderCell: (params) => <DateCell date={params.row.createdAt} />,
      },
    ];
  }, [t, isFieldSortable]);

  return { columns };
};
